import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import * as Text from 'theme/components/Text.style';
import { skeletonPulseAnimation } from 'shared/_styles/Skeleton.style';

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;

  > button,
  > a {
    flex-grow: 0;
    width: fit-content;
  }
`;

export const OverviewLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 3fr) minmax(0, 2fr);
  gap: 20px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 40px;
`;

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 20px;

  p {
    color: ${colours.neutral[900]};
  }
`;

export const SummaryHeading = styled(Text.P2Bold)`
  color: ${colours.neutral[900]};
`;

export const SummarySkeletonLine = styled.div<{ $width: string }>`
  ${skeletonPulseAnimation}
  background: ${colours.neutral[200]};
  border-radius: 4px;
  height: 10px;
  width: ${({ $width }) => $width};
`;

export const SummarySkeletonBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 6px 0;
`;

export const SummaryText = styled(Text.P2)`
  color: ${colours.neutral[900]};
`;

export const SummaryNote = styled(Text.P1)`
  color: ${colours.neutral[500]};
`;

export const SummaryError = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Card = styled.div`
  flex: 1;
  background: ${colours.shade[0]};
  border-radius: 40px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SummaryCardContainer = styled(Card)`
  gap: 7px;
`;

export const CardTitle = styled.div`
  display: flex;
  align-items: center;
  min-height: 30px;
`;

export const StatRowsContainer = styled.div`
  display: flex;
  flex-direction: column;

  p {
    color: ${colours.neutral[900]};
  }
`;

export const NumbersStatRow = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  padding: 10px 0;
  text-align: center;
`;

export const HorizontalStatRow = styled.div`
  display: flex;
  align-items: last baseline;
  justify-content: space-between;
  gap: 20px;
  padding: 10px 0;
  border-bottom: 1px solid ${colours.neutral[100]};
  overflow: clip;
`;

export const UrgencyStatRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 10px 0;
  border-bottom: 1px solid ${colours.neutral[100]};
  overflow: clip;
`;
